import React from 'react';

const sortingIcon = (props) => {

  if (props.currentColumn === props.sortColumn) {
    if (props.sortDirection === 1){
      return (
        <span className="material-icons" style={{fontSize: 'inherit', marginRight: '5px'}}>
        south
        </span>
      )
    } else {
      return (
        <span className="material-icons" style={{fontSize: 'inherit', marginRight: '5px'}}>
        north
        </span>
    )
    }

  } else {
    return (
      <span className="material-icons" style={{fontSize: 'inherit', marginRight: '5px'}}>
      east
      </span>
    )
  }

};

export default sortingIcon;



// WEBPACK FOOTER //
// ./src/components/UI/SortingIcon.js